/** SMS文字数制限（日本語 = UCS-2エンコーディング） */
export const SMS_SINGLE_LIMIT = 70;
export const SMS_SEGMENT_LIMIT = 67;
export const SMS_MAX_CHARS = 670; // 10セグメント上限

/** 送信時に自動付与されるプレフィックス */
export const SMS_PREFIX = "【スフィアライト】";

/** 変数ごとの推定最大文字数 */
const VAR_ESTIMATED_LENGTH: Record<string, number> = {
  contact_name: 10,
  customer_name: 10,
  company_name: 20,
  staff_name: 8,
  staff_name_last: 4,
  booking_url: 40,
  order_id: 12,
  ship_date: 10,
  tracking_no: 15,
  tracking_url: 50,
  review_url: 50,
  due_date: 10,
};
const DEFAULT_VAR_LENGTH = 15;

export interface SmsCharInfo {
  /** テンプレートそのままの文字数 */
  rawChars: number;
  /** プレフィックス + 変数展開見込みの推定最大文字数 */
  estimatedChars: number;
  segments: number;
  remaining: number;
  overLimit: boolean;
}

/**
 * テンプレート本文の文字数情報を返す。
 * プレフィックス（自動付与分）と変数の推定展開長を加味する。
 */
export function countSmsChars(text: string): SmsCharInfo {
  const rawChars = text.length;
  if (rawChars === 0) {
    return { rawChars: 0, estimatedChars: SMS_PREFIX.length, segments: 0, remaining: SMS_SINGLE_LIMIT - SMS_PREFIX.length, overLimit: false };
  }

  // 変数を推定長に置換して推定文字数を計算
  const expanded = text.replace(/\{\{(\w+)\}\}/g, (_match, key) => {
    const len = VAR_ESTIMATED_LENGTH[key] ?? DEFAULT_VAR_LENGTH;
    return "X".repeat(len);
  });
  const estimatedChars = SMS_PREFIX.length + expanded.length;

  const segments =
    estimatedChars <= SMS_SINGLE_LIMIT ? 1 : Math.ceil(estimatedChars / SMS_SEGMENT_LIMIT);
  const capacity =
    estimatedChars <= SMS_SINGLE_LIMIT ? SMS_SINGLE_LIMIT : SMS_MAX_CHARS;
  return {
    rawChars,
    estimatedChars,
    segments,
    remaining: capacity - estimatedChars,
    overLimit: estimatedChars > SMS_MAX_CHARS,
  };
}
